import script from "./OrganizationIntegrations.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrganizationIntegrations.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__